/**
 * Caches that live as long as the browser tab, for data that rarely or never
 * changes while the app is open: PLSS section shapes and OCC overlays (no
 * expiry), and field metadata and lookup lists (with a TTL and clear-on-write;
 * see services/referenceCache). Without them every map mount refetched the
 * same county shapes, at 15-30 s a county.
 *
 * Callers put the signed-in user's oid in every key, so a second account in
 * the same tab never reads the first one's entries. Same idea as the Mapbox
 * token cache in hooks/useMapboxToken.
 */
const caches = new Set();

/** A new tab-lifetime Map, registered so clearSessionCaches() empties it. */
export const sessionCache = () => {
  const cache = new Map();
  caches.add(cache);
  return cache;
};

/** Empties every session cache (the test setup runs this between tests). */
export const clearSessionCaches = () => {
  for (const cache of caches) cache.clear();
};
